module.exports = __webpack_public_path__ + "media/images/partners/chocolate-d0ed6d6c14b2fe08d6d2d30d8e2d135d.png";